import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import util from "../util/util";

export default function RuleDetailSchedule(props) {
  const timeslots = props.timeslots || [];
  const shows = props.shows || [];

  return (
    <div>
      <h3 className="page__header">Schedule</h3>

      <div className="well">
        <div className="row">
          <div className="col-sm-3">
            <h4 className="page__header">Start Date</h4>
            <p>{moment(props.startDate).format(util.dateFormatHumanLong)}</p>
          </div>

          <div className="col-sm-3">
            <h4 className="page__header">End Date</h4>
            <p>{moment(props.endDate).format(util.dateFormatHumanLong)}</p>
          </div>

          <div className="col-sm-3">
            {props.timeslots && timeslots.length > 0 ? (
              <div>
                <h4 className="page__header">
                  Time Slot{timeslots.length > 1 ? `s` : ``}
                </h4>
                {util.returnCleanTimeSlots(timeslots).map((timeslot, index) => (
                  <p key={index}>{timeslot}</p>
                ))}
              </div>
            ) : (
              <div>
                <h4 className="page__header">
                  Show{shows.length > 1 ? `s` : ``}
                </h4>
                {util.returnShowNames(shows).map((show, index) => (
                  <p key={index}>{show}</p>
                ))}
              </div>
            )}
          </div>

          <div className="col-sm-3">
            <h4 className="page__header">Repeats</h4>
            {props.frequency === 1 && renderRepeatsMonthly(props.rule)}

            {props.frequency === 2 && renderRepeatsWeekly(props.rule)}

            {props.frequency === 3 && renderRepeatsDaily(props.frequency)}
          </div>
        </div>
      </div>
    </div>
  );
}

RuleDetailSchedule.propTypes = {
  endDate: PropTypes.string, // schedule end date;
  frequency: PropTypes.number, // rule repeats value;
  rule: PropTypes.object, // rule details;
  startDate: PropTypes.string, // schedule start date;
  timeslots: PropTypes.array // timeslots for this rule;
};

// transform array of day ids into text;
function renderDays(values) {
  const labels = [];

  // daysArray contains the text values;
  util.days.forEach(day => {
    if (values.indexOf(day.value) > -1) {
      labels.push(day.label);
    }
  });

  // return array of text from an array of ids;
  return labels;
}

// render content for monthly schedule;
function renderRepeatsMonthly(rule) {
  return (
    <p id="rule-detail-schedule__repeats--monthly">
      On the {returnOrdinal(rule.bymonthday)} day, every {rule.interval}{" "}
      {rule.interval > 1 ? `months` : `month`}.
    </p>
  );
}

// render content for weekly schedule;
function renderRepeatsWeekly(rule) {
  const weekLabel = rule.interval > 1 ? `weeks` : `week`;

  return (
    <div id="rule-detail-schedule__repeats--weekly">
      Every {rule.interval} {weekLabel} on:
      <ul>
        {renderDays(rule.byweekday).map(day => {
          return <li key={day}>{day}</li>;
        })}
      </ul>
    </div>
  );
}

// render content for daily schedule;
function renderRepeatsDaily(frequency) {
  return (
    <p id="rule-detail-schedule__repeats--daily">
      {util.returnRepeatValue(frequency)}
    </p>
  );
}

// transform number into number-string (1st, 2nd, etc);
function returnOrdinal(i) {
  const j = i % 10;
  const k = i % 100;

  if (j === 1 && k !== 11) {
    return i + `st`;
  }

  if (j === 2 && k !== 12) {
    return i + `nd`;
  }

  if (j === 3 && k !== 13) {
    return i + `rd`;
  }

  return i + `th`;
}
